import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { GeneralCarePlanComponent } from './general-care-plan.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { MatDatepickerModule, MAT_DATE_LOCALE, MatFormFieldModule, MatNativeDateModule,
  MatInputModule, MatSelectModule } from '@angular/material';
import { TherapyDiscontinuationComponent } from '../therapy-discontinuation/therapy-discontinuation.component';
import { ModalsModule } from '../../../widgets/entry-components/modal/modals.module';
import { AngularEditorModule } from '@kolkov/angular-editor';


@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    ReactiveFormsModule,
    ModalsModule,
    MatSelectModule,
    AngularEditorModule
  ],
  declarations: [GeneralCarePlanComponent, TherapyDiscontinuationComponent],
  exports: [GeneralCarePlanComponent],
  entryComponents: [TherapyDiscontinuationComponent],
  providers: [
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' }
  ]
})
export class GeneralCarePlanModule { }
